import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetOfferedDriverQueryVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
}>;


export type GetOfferedDriverQuery = { __typename?: 'query_root', drivers_by_pk?: { __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null, email?: string | null } | null } | null };


export const GetOfferedDriverDocument = gql`
    query getOfferedDriver($driverId: bigint!) {
  drivers_by_pk(id: $driverId) {
    id
    status
    user {
      id
      display_name
      avatar_url
      phone
      email
    }
  }
}
    `;

/**
 * __useGetOfferedDriverQuery__
 *
 * To run a query within a React component, call `useGetOfferedDriverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferedDriverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferedDriverQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useGetOfferedDriverQuery(baseOptions: Apollo.QueryHookOptions<GetOfferedDriverQuery, GetOfferedDriverQueryVariables> & ({ variables: GetOfferedDriverQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>(GetOfferedDriverDocument, options);
      }
export function useGetOfferedDriverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>(GetOfferedDriverDocument, options);
        }
// @ts-ignore
export function useGetOfferedDriverSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>;
export function useGetOfferedDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferedDriverQuery | undefined, GetOfferedDriverQueryVariables>;
export function useGetOfferedDriverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>(GetOfferedDriverDocument, options);
        }
export type GetOfferedDriverQueryHookResult = ReturnType<typeof useGetOfferedDriverQuery>;
export type GetOfferedDriverLazyQueryHookResult = ReturnType<typeof useGetOfferedDriverLazyQuery>;
export type GetOfferedDriverSuspenseQueryHookResult = ReturnType<typeof useGetOfferedDriverSuspenseQuery>;
export type GetOfferedDriverQueryResult = Apollo.QueryResult<GetOfferedDriverQuery, GetOfferedDriverQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getOfferedDriver.query.gql}
 */
export async function getOfferedDriver(
  variables: GetOfferedDriverQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetOfferedDriverQuery['drivers_by_pk']>
export async function getOfferedDriver(
  variables: GetOfferedDriverQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetOfferedDriverQuery>
export async function getOfferedDriver(
  variables: GetOfferedDriverQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetOfferedDriverQuery['drivers_by_pk'] | GetOfferedDriverQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetOfferedDriverQuery>(
    GetOfferedDriverDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers_by_pk
}